import { Button, Modal } from 'react-bootstrap';
import { useState } from 'react';

export const Delete = ({ onConfirm, disabled }) => {
  const [show, setShow] = useState(false);

  // Функции для открытия и закрытия модального окна
  const handleShow = () => {
    if (!disabled) {
      setShow(true);
    }
  };
  const handleClose = () => setShow(false);

  // Обработчик подтверждения удаления
  const handleConfirm = () => {
    onConfirm(); // Вызываем переданную функцию
    handleClose(); // Закрываем модальное окно
  };

  return (
    <>
      {/* Кнопка удаления */}
      <svg
        style={{
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
        }}
        title={disabled ? 'Нельзя удалить элемент по умолчанию' : 'Удалить'}
        onClick={handleShow}
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="15"
        viewBox="0 0 18 15"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.0001 0H6.10352e-05V3C1.10463 3 2.00006 3.89543 2.00006 5V9C2.00006 11.8284 2.00006 13.2426 2.87874 14.1213C3.75742 15 5.17163 15 8.00006 15H10.0001C12.8285 15 14.2427 15 15.1214 14.1213C16.0001 13.2426 16.0001 11.8284 16.0001 9V5C16.0001 3.89543 16.8955 3 18.0001 3V0ZM7.50006 5C7.50006 4.44772 7.05235 4 6.50006 4C5.94778 4 5.50006 4.44772 5.50006 5V10C5.50006 10.5523 5.94778 11 6.50006 11C7.05235 11 7.50006 10.5523 7.50006 10V5ZM12.5001 5C12.5001 4.44772 12.0523 4 11.5001 4C10.9478 4 10.5001 4.44772 10.5001 5V10C10.5001 10.5523 10.9478 11 11.5001 11C12.0523 11 12.5001 10.5523 12.5001 10V5Z"
          fill="rgb(225, 96, 112)"
        />
      </svg>

      {/* Модальное окно подтверждения */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Подтверждение удаления</Modal.Title>
        </Modal.Header>
        <Modal.Body>Вы уверены, что хотите удалить?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Отмена
          </Button>
          <Button variant="danger" onClick={handleConfirm}>
            Удалить
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
